import { render } from "./CreateCollectionOrderModal.html?vue&type=template&id=52d8ee6d&scoped=true"
import script from "./CreateCollectionOrderModal.js?vue&type=script&lang=js"
export * from "./CreateCollectionOrderModal.js?vue&type=script&lang=js"

import "./CreateCollectionOrderModal.css?vue&type=style&index=0&id=52d8ee6d&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d8ee6d"]])

export default __exports__